interface ActionCardProps {
  title: string
  description: string
  buttonText: string
  buttonClassName?: string
  buttonStyle?: React.CSSProperties
  disabled?: boolean
  onClick: () => void
}

export function ActionCard({
  title,
  description,
  buttonText,
  buttonClassName,
  buttonStyle,
  disabled = false,
  onClick,
}: ActionCardProps) {
  return (
    <div className="w-[535px] bg-white border border-[#ebebeb]">
      <div className="p-6 flex flex-col gap-5 items-center justify-center">
        <div className="w-full flex flex-col gap-6 items-start">
          <div className="w-full flex flex-col gap-2 items-start">
            <div className="w-full flex flex-col gap-2 items-start">
              <div className="w-full flex flex-col items-start">
                <div className="w-full flex flex-col items-start justify-center overflow-hidden">
                  <h3 className="text-sm font-medium text-[rgba(0,0,0,0.85)] font-['Roboto'] leading-6">
                    {title}
                  </h3>
                </div>
                <p className="text-sm font-normal text-[rgba(0,0,0,0.45)] font-['Roboto'] leading-6 w-full">
                  {description}
                </p>
              </div>
            </div>
          </div>
          <div className="flex gap-2 items-start">
            <button
              className={`${buttonClassName || ''} disabled:cursor-not-allowed disabled:opacity-50`}
              style={buttonStyle}
              onClick={onClick}
              disabled={disabled}
            >
              <span className="text-sm font-normal text-white font-['Roboto'] leading-[22px]">
                {buttonText}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
